import { parse } from "date-fns";
import { cs, enUS, pl } from "date-fns/locale";

const ISO_DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const SATURDAY_WEEKDAY = 6;
const SUNDAY_WEEKDAY = 0;

const parseDateStringForWeekday = (value: string): Date => {
  if (ISO_DATE_ONLY.test(value)) {
    return parse(value, "yyyy-MM-dd", new Date(0));
  }
  return new Date(value);
};

export const haveSaturdays = (dates?: string[]): boolean =>
  Boolean(
    dates?.some(
      (date) => parseDateStringForWeekday(date).getDay() === SATURDAY_WEEKDAY,
    ),
  );

export const haveSundays = (dates?: string[]): boolean =>
  Boolean(
    dates?.some(
      (date) => parseDateStringForWeekday(date).getDay() === SUNDAY_WEEKDAY,
    ),
  );

// When some of the saved delivery days are no longer available (edit-from-cart
// flow), they are simply dropped. Nothing is picked for the user instead: a
// replacement day appended by the system could be one the customer did not
// want and would go unnoticed on a quick "save" (BOK case fc7394: a skipped
// week came back into a paid order). The days the user kept are never touched,
// so the calendar shows exactly their choice minus what expired, and the day
// count follows.
export const dropUnavailableDates = ({
  dates,
  isDateAvailable,
}: {
  dates: Date[];
  isDateAvailable: (date: Date) => boolean;
}): Date[] =>
  [...dates].sort((a, b) => a.getTime() - b.getTime()).filter(isDateAvailable);

export const getDateLocale = (locale: string) => {
  switch (locale) {
    case "cz":
      return cs;
    case "en":
      return enUS;
    case "pl":
      return pl;
    default:
      return pl;
  }
};
